import { useGetCurrentUserQuery } from "../api/backendApi";
import { annaProfiiliTrivoreKayttajalle } from "../utils/oikeudet";

export function useTodellinenRooli() {
  const { data: kayttaja, isLoading, error } = useGetCurrentUserQuery();
  const todellinenRooli = annaProfiiliTrivoreKayttajalle(kayttaja);
  return { kayttaja, todellinenRooli, isLoading, error };
}
